import { NgModule } from '@angular/core';
import { LocalizationStoreModule } from './store/module';

@NgModule({
  imports: [LocalizationStoreModule],
})
export class LocalizationModule {}
